/**
 * Created by Languagenut on 02/07/2019.
 */


/**
 * Created by Languagenut on 02/07/2019.
 */


/**
 * Created by Languagenut on 02/07/2019.
 */



import React  from 'react';
import {Media , Navbar , Form , Button , Card , Row , Col , Nav , ButtonGroup} from 'react-bootstrap'
import Slider from "react-slick";

class MinApp extends React.Component {
    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    render(){

        return <div>

            <Media>
                <img
                    width={64}
                    height={64}
                    className="mr-3"
                    src="holder.js/64x64"
                    />
                <Media.Body>
                    <b>Media Heading</b><br/>
                    <small>By: Mark James Smith</small><br/>
                    <small>Created: 02/02/19</small>
                </Media.Body>
            </Media>
        </div>
    }
}

class FeaturedApp extends React.Component {
    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    render(){

        return <div>

            <Media>
                <img
                    width={120}
                    height={64}
                    className="mr-3"
                    src="holder.js/64x64"
                    />
                <Media.Body>
                    <b>Media Heading</b><br/>
                    <small>By: Mark James Smith</small><br/>
                    <small>Created: 02/02/19</small>
                </Media.Body>
            </Media>
        </div>
    }
}

export default class Featured extends React.Component {


    constructor(props) {
        super();
        this.props = props;
        this.state = {

        };
    }

    componentDidMount() {

    }

    componentWillReceiveProps(props){

    }

    onNavigationSelect(){


    }

    render(){

        var settings = {
            dots: true,
            infinite: true,
            speed: 500,
            slidesToShow: 3,
            slidesToScroll: 1
        };
        return (
            <div  style={{padding:"0px"}}>
                <h6>This is a section header</h6>
                <br/>
                <Slider {...settings}>
                    <div>
                        <MinApp />
                    </div>
                    <div>
                        <MinApp />
                    </div>
                    <div>
                        <MinApp />
                    </div>
                    <div>
                        <MinApp />
                    </div>
                    <div>
                        <MinApp />
                    </div>
                    <div>
                        <MinApp />
                    </div>
                </Slider>
            </div>
        );


    }

}